import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { LookInside } from './components/LookInside';
import { MetaPixel, PIXEL_ID } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductShowcase } from './components/ProductShowcase';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonials } from './components/Testimonials';
import { Volumes } from './components/Volumes';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-slate-50 text-brand-deep selection:bg-gold-light selection:text-brand-deep" data-id="element-0" data-mp="28ufpyg1ohml6">
      <MetaPixel data-id="element-1" data-mp="23u9ueosaffxt" />
      <main data-id="element-2" data-mp="23utby4e102bb">
        <Hero data-id="element-3" data-mp="23v2uj6wqr76z" />
        <ProblemSolution data-id="element-4" data-mp="23ti7018ugoim" />
        <ProductShowcase data-id="element-5" data-mp="3ikh829m9asyz" />
        <Volumes data-id="element-6" data-mp="3ij64oawq3n8e" />
        <LookInside data-id="element-7" data-mp="3ijpbavgxap74" />
        <Bonuses data-id="element-8" data-mp="3ii4ro0w5cqo1" />
        <Pricing data-id="element-9" data-mp="3mlaxx8j9ehui" />
        <Differentiators data-id="element-10" data-mp="3mkrbpfmkt7ao" />
        <Testimonials data-id="element-11" data-mp="3mjzs7369700r" />
        <Faq data-id="element-12" data-mp="3mjg8pi0yg3km" />
        <FinalClose data-id="element-13" data-mp="3rc9e8848zfxr" />
      </main>
      <Footer data-id="element-14" data-mp="3rbzq6q2rjiup" />
      <PurchasePopup data-id="element-15" data-mp="3rdkg22e4udm8" />
      <noscript data-id="element-16" data-mp="3rd17vdeab3le">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-17" data-mp="3relwynhtxubv" />
      </noscript>
    </div>;
}